export const DUE_DATES_ONLY_EXPORT_COLUMN_IDS = Object.freeze([
  'jobNumber',
  'modelNumber',
  'projectName',
  'mechanicalDue',
  'electricalDue',
  'npPipeFabDue',
  'fusionBondRequired',
  'fabDue',
  'softwareDue',
  'controlPanelDue',
  'hcPumpsDue',
  'vtPumpsDue',
  'assemblyDue',
  'testDue',
  'npCsmDue',
  'npSuctionLineDue',
  'npInducerTubeDue',
  'npBmxDue',
  'packDue',
  'transportType',
  'currentPlanShipDate',
  'scheduledArrivalDate',
  'salesRep',
  'jobLocation',
  'notes',
  'paymentTerms',
  'leadTime',
]);

const DUE_DATES_ONLY_EXPORT_COLUMN_ID_SET = new Set(
  DUE_DATES_ONLY_EXPORT_COLUMN_IDS
);

export const shouldSelectExportColumnByDefault = ({
  column,
  dueDatesOnly,
  sectionSelected,
}) => {
  if (column.required) return true;
  if (!sectionSelected) return false;
  if (!dueDatesOnly) return true;
  return DUE_DATES_ONLY_EXPORT_COLUMN_ID_SET.has(column.id);
};
